<template>
  <div>
    <div
      class="page-header clear-filter d-flex justify-content-center align-items-center"
      filter-color="dark"
    >
      <parallax
        class="page-header-image"
        style="background-color:#26a23e"
      ></parallax>
      <div class="content-center">
        <div class="container">
          <div class="content-center brand">
            <h1 class="h1-seo">Políticas de Privacidad</h1>
          </div>
        </div>
      </div>
      <vue-particles
        color="#bbbbbb"
        :particleOpacity="0.5"
        :lineOpacity="0.3"
        :clickEffect="false"
      ></vue-particles>
    </div>

    <div class="section">
      <div class="features">
        <div class="container">
          <div class="row">
            <div class="col-12 text-justify">
              <main class="notion">
                <h3 class="notion-h1">GENERALIDADES</h3>
                <p class="notion-text">
                  Este aviso de privacidad para
                  <b>Eficiencia Energética y Seguridad S.A. de C.V, </b
                  >denominados como <b>PROYECTOS EES</b>, solicitamos que para
                  hacer uso de nuestra página web:
                  <a href="https://proyectosees.com/" class="notion-link"
                    >https://proyectosees.com</a
                  >, previamente lea detenidamente esta política de privacidad,
                  para que pueda comprender bajo que términos sus datos serán
                  recopilados, procesados, y almacenados por parte de “PROYECTOS
                  EES”, enfocados en proporcionarle un mejor servicio.
                </p>
                <p class="notion-text">
                  Leer este aviso de privacidad le ayudará a comprender sus
                  derechos y opciones de privacidad. Si no está de acuerdo con
                  nuestras políticas y prácticas, favor desistir del uso de
                  nuestros servicios.
                </p>
                <p class="notion-text">
                  Los usuarios garantizan y responden, en cualquier caso, de la
                  veracidad, exactitud, vigencia y autenticidad de la
                  Información Personal facilitada, y se comprometen a mantenerla
                  debidamente actualizada. A los efectos de la presente
                  Política, los usuarios serán referidos como “Usuarios” o
                  “Usuario”.
                </p>
                <h3 class="notion-h1">PRINCIPIOS DE LA POLÍTICA</h3>
                <ol start="1" class="notion-list notion-list-numbered">
                  <li>
                    <p class="notion-text">
                      <b>Principio de Legalidad:&nbsp;</b>El tratamiento de la
                      información se apegará a las leyes y normas vigentes en la
                      República de El Salvador, que regulan el tratamiento de la
                      información y protegen los derechos
                      fundamentales.&nbsp;Esto incluye el cumplimiento de las
                      disposiciones contractuales acordadas con los usuarios.
                    </p>
                  </li>
                  <li>
                    <p class="notion-text">
                      <b>Principio de Libertad:&nbsp;</b>El consentimiento del
                      usuario es un principio fundamental a la hora de tratar
                      datos personales.&nbsp;Es imprescindible que el usuario
                      proporcione su consentimiento previo, expreso e
                      informado.&nbsp;Los datos personales, especialmente si no
                      se consideran públicos, no pueden obtenerse ni compartirse
                      sin la debida autorización, salvo que lo exija una ley o
                      una orden judicial.
                    </p>
                  </li>
                  <li>
                    <p class="notion-text">
                      <b>Principio de Finalidad:&nbsp;</b>El procesamiento de
                      información no pública a la que accede y recopila
                      "PROYECTOS EES" estará sujeto a un propósito legítimo,
                      como se describe en esta política, asegurando que sirve a
                      un objetivo específico.
                    </p>
                  </li>
                  <li>
                    <p class="notion-text">
                      <b>Principio de Veracidad o Calidad:&nbsp;</b>La
                      información protegida sujeta a tratamiento debe ser veraz,
                      completa, exacta, actualizada, comprobable y comprensible.
                      PROYECTOS EES no será responsable frente al usuario cuando
                      sean objeto de tratamiento, datos o información parcial,
                      incompleta o fraccionada o que induzca a error, entregada
                      por el usuario sin que existiera la forma de ser
                      verificada la veracidad o calidad de la misma por parte de
                      PROYECTOS EES o la misma hubiere sido entregada o
                      divulgada por el Usuario declarando o garantizando, de
                      cualquier forma, su veracidad o calidad.
                    </p>
                  </li>
                  <li>
                    <p class="notion-text">
                      <b>Principio de Transparencia:&nbsp;</b>En el tratamiento
                      de información protegida, se garantizará el derecho del
                      Usuario a obtener de PROYECTOS EES, en cualquier momento y
                      sin restricciones, información acerca de la existencia de
                      cualquier tipo de información protegida que sea de su
                      interés (legal, judicial o contractualmente justificado) o
                      titularidad.
                    </p>
                  </li>
                  <li>
                    <p class="notion-text">
                      <b>Principio de Acceso y Circulación Restringida:&nbsp;</b
                      >La información protegida no estará disponible en Internet
                      u otros medios de divulgación o comunicación masiva, salvo
                      que el acceso sea técnicamente controlable para brindar un
                      conocimiento restringido sólo a PROYECTOS EES, las
                      Sociedades Vinculadas, los usuarios o terceros debidamente
                      autorizados por el usuario.
                    </p>
                  </li>
                  <li>
                    <p class="notion-text">
                      <b>Principio de Seguridad:&nbsp;</b>La información
                      protegida bajo la Política sujeta a tratamiento por
                      PROYECTOS EES a, será objeto de protección en la medida en
                      que los recursos técnicos y estándares mínimos así lo
                      permitan, a través de la adopción de medidas tecnológicas
                      de protección, protocolos, y medidas administrativas que
                      sean necesarias para otorgar seguridad a los registros y
                      repositorios electrónicos evitando su adulteración,
                      modificación, pérdida, consulta, y en general en contra de
                      cualquier uso o acceso no autorizado.
                    </p>
                  </li>
                  <li>
                    <p class="notion-text">
                      <b>Principio de Confidencialidad:</b>
                      Todas y cada una de las personas que en PROYECTOS EES
                      administran, manejan, actualizan o tienen acceso a
                      información protegida que no tenga el carácter de pública,
                      y se encuentre en sistemas de información o bases o bancos
                      de datos de terceros debidamente autorizados, se
                      comprometen a conservar y mantener de manera estrictamente
                      confidencial y no revelar a terceros todas o cualesquiera
                      de las informaciones personales, comerciales, contables,
                      técnicas, o de cualquier otro tipo suministradas en la
                      ejecución y ejercicio de sus funciones. PROYECTOS EES y
                      sus Sociedades Vinculadas para el tratamiento de la
                      información protegida podrán utilizar los sistemas de
                      información y bases de datos de propiedad de PROYECTOS EES
                    </p>
                  </li>
                </ol>
                <h3 class="notion-h1">INFORMACIÓN RECOGIDA</h3>
                <p class="notion-text">
                  Cuando usted hace uso de la aplicación de PROYECTOS EES como
                  usuario se podrá recoger la información que introduzca dentro
                  de ella. En específico, aquella que recolectamos consiste en:
                </p>

                <p class="notion-text">
                  <b>Datos generales de identidad</b>: entendidos como el
                  nombre, número de teléfono, dirección física y correo
                  electrónico, ID de usuario.
                </p>
                <p class="notion-text">
                  <b>Datos de ubicación/geolocalización</b>: los cuales son
                  obtenidos por medio de las coordenadas geográficas, latitud y
                  longitud que brinda el usuario por medio de la aplicación, la
                  cual este puede brindarla o no por medio de la solicitud de
                  permiso que PROYECTOS EES envía al usuario por medio de los
                  permisos en el dispositivo.
                </p>
                <p class="notion-text">
                  <b>Cookies</b>: es una pequeña porción de data generada por un
                  sitio web y almacenada por el mismo. La cual es usada para
                  identificar un navegador, proveer análisis, recordar
                  información tuya como tu lenguaje, preferencias o información
                  de acceso.
                </p>
                <p class="notion-text">
                  <b>Historial de servicios</b>: Es el registro detallado de
                  todas las compras realizadas en la app/web por un usuario
                  determinado, se recopila con el fin de conocer los hábitos de
                  consumo del usuario y con base en ello emitir recomendaciones,
                  realizar publicidad, etc. Interacciones en la app/web:
                  Consiste en el registro pormenorizado de los servicios, entre
                  otras funciones de la app con las cuales el usuario interactúa
                  por medio de clicks o toques. Se recopila para fines diversos,
                  entre ellos mejorar la experiencia de usuario o saber que
                  servicios despiertan mayor interés entre los usuarios.
                </p>
                <p class="notion-text">
                  <b>Historial de búsqueda</b>: Es el registro detallado de
                  todas las búsquedas realizadas en la app/web por un usuario
                  determinado, se recopila con el fin de conocer los intereses
                  de servicios del usuario y con base en ellos mejorar los
                  ofrecidos.
                </p>
                <p class="notion-text">
                  <b>Registro de fallas</b>: Información recopilada con el fin
                  de mejorar la experiencia del usuario y lograr un rendimiento
                  óptimo de la app/web.
                </p>
                <p class="notion-text">
                  <b>Dispositivo u otros ID</b>: Información relacionada con el
                  dispositivo utilizado por el usuario para ingresar a la
                  app/web. Se recopila por fines meramente estadísticos o de
                  mejora.
                </p>
                <p class="notion-text">
                  <b>Otra información:</b> Información que el usuario nos provea
                  voluntariamente mientras utiliza el sitio web o la aplicación
                  e información de otras fuentes tales como redes sociales o
                  aplicaciones que utilicen nuestra interfaz de conexión u otras
                  bases de datos públicas.
                </p>
                <p class="notion-text">
                  En cualquiera de los casos antes indicados, por favor tenga
                  presente que toda información que usted nos provea según lo
                  antes descrito, PROYECTOS EES la considera información
                  personal suya y por tanto si nos provee información personal
                  de otra persona, PROYECTOS EES no será responsable de obtener
                  el consentimiento previo de esa otra persona para tratar
                  dichos datos personales según estas Políticas de Privacidad,
                  carga que le será imputable a usted de forma exclusiva por
                  hacer uso y tratamiento de datos personales de terceros,
                  entendiéndose en todo momento que, respecto de dichos datos,
                  usted es el Responsable del Tratamiento.
                </p>
                <p class="notion-text">
                  Solo recolectamos sus datos personales cuando es necesario y
                  la finalidad es lícita y previamente definida. PROYECTOS EES
                  recopila y usa su información personal para los propósitos
                  especificados en esta Política o en las secciones relevantes
                  de nuestro Portal.
                </p>
                <p class="notion-text">
                  PROYECTOS EES Utiliza su información para distintos fines:
                </p>
                <p class="notion-text"><b>Prestación de servicios: </b></p>
                <p class="notion-text">
                  Utilizamos su información para ofrecer, personalizar, mantener
                  y mejorar la prestación de los servicios que les ofrecemos a
                  nuestros usuarios, así como realizar las siguientes
                  actividades:
                </p>
                <ul class="notion-list notion-list-disc">
                  <li>Administrar el sitio web.</li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>Crear y actualizar su cuenta.</li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>Verificar su perfil.</li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Mejorar su experiencia de navegación personalizando el
                    Portal.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Habilitarlo a usted para el uso de los servicios disponibles
                    en el Portal.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>Enviarle comunicados comerciales generales.</li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Realizar comentarios y valoraciones de los comercios
                    adheridos, su oferta y servicios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>Procesar y realizar el pago de los pedidos.</li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Controlar el seguimiento de servicio, para garantizar la
                    finalización de este.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>Activar funciones para personalizar su cuenta.</li>
                </ul>
                <p class="notion-text">
                  <b>Servicio de Atención al Cliente: </b>Cuando el usuario
                  presente un reclamo, se almacena información que nos facilita
                  a poder resolver, y según el tipo de reclamo la información
                  solicitada variará, enfocado en resolver a la brevedad.
                </p>
                <p class="notion-text">
                  <b>Protección y seguridad: </b>Utilizamos sus datos personales
                  para mantener la protección, seguridad e integridad de
                  nuestros servicios y usuarios. Asimismo, utilizamos la
                  información para prevenir fraudes.
                </p>
                <p class="notion-text">
                  <b>Investigación y desarrollo: </b>Podemos utilizar la
                  información que recopilamos para testear, investigar, analizar
                  y desarrollar servicios. Esto permite que podamos mejorar en
                  términos de seguridad y que podamos desarrollar nuevas
                  funciones o servicios.
                </p>
                <p class="notion-text">
                  <b>Publicidad</b>: Podemos enviarte correos electrónicos, SMS,
                  push notifications o realizar llamadas a tu móvil, teléfono
                  fijo o cualquier otro dispositivo que sea susceptible de
                  recibir llamadas para ofrecerte vouchers, descuentos y
                  promociones, realizar encuestas y para realizar encuestas o
                  sondeos de opinión para mejorar nuestro servicio y la calidad
                  del mismo. El usuario puede oponerse al tratamiento posterior
                  de los datos con fines publicitarios con cada correo
                  electrónico o en los ajustes en el Portal.
                </p>
                <p class="notion-text">
                  <b>Marketing</b>. Nuestro objetivo es mantenernos alejados de
                  boletines genéricos y tácticas de marketing no
                  reguladas.&nbsp;Como resultado, seleccionamos cuidadosamente
                  las ofertas que se alinean con sus intereses específicos y nos
                  comunicamos con usted si creemos que la información sería
                  relevante para usted.&nbsp;Si desea optar por no recibir más
                  anuncios, tiene la opción de hacerlo con cada correo
                  electrónico.
                </p>
                <p class="notion-text">
                  PROYECTOS EES tiene la capacidad de utilizar la información
                  proporcionada con el fin de promover y facilitar concursos y
                  rifas, distribuir premios y entregar publicidad y contenido
                  que sean relevantes para nuestros servicios, así como los
                  servicios de nuestros socios comerciales y empresas afiliadas.
                </p>
                <p class="notion-text">
                  <b
                    >Procedimientos judiciales o requerimientos administrativos: </b
                  >Si es requerido<b> </b>por orden judicial o resolución
                  administrativa, regulatoria, arbitral, administrativa, y en
                  general cuando sea requerido por cualquier autoridad
                  gubernamental, podremos utilizar su información.
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">
                  DATOS QUE PUEDEN SER COMPARTIDOS CON TERCEROS
                </h3>
                <p class="notion-text">
                  De todos los datos recopilados anteriormente, al hacer uso de
                  la app el usuario a PROYECTOS EES el derecho de compartir con
                  terceros (principalmente, socios/profesionales independientes,
                  comercios afiliados) los siguientes datos recopilados: Datos
                  de ubicación/geolocalización: Se comparte con co-workers
                  afiliados para que estos puedan conocer las zonas donde más se
                  visualizan la solicitud de servicios. Historial de servicios:
                  Se comparte con comercios afiliados para que puedan conocer
                  los productos que se han requerido para los servicios
                  contratados, con el fin de que mejoren su oferta.
                  Interacciones en la app/web: Se comparte con socios
                  profesionales para que puedan conocer como los usuarios
                  interactúan con los servicios que requieren y con base en
                  dicha información adoptar las estrategias que consideren
                  convenientes. Dispositivo u otros ID: Se comparte con
                  comercios afiliados para que estos puedan conocer más a
                  profundidad a sus consumidores, así como puede compartirse con
                  otras empresas para fines meramente estadísticos.
                </p>
                <h3 class="notion-h1">
                  ACTUALIZACIÓN DE LA INFORMACIÓN
                </h3>
                <p class="notion-text">
                  Si su información cambia o ha cambiado, es usted el
                  responsable de modificarla en la aplicación. Esto permitirá el
                  correcto funcionamiento del sitio, así como la mejor
                  orientación para clasificar los servicios con base a su
                  conocimiento o experiencia.
                </p>
                <p class="notion-text">
                  Si usted actualiza y/o modifica sus datos personales,
                  ”PROYECTOS EES” conservará la información personal anterior
                  por motivos de seguridad y control del fraude.
                </p>
                <h3 class="notion-h1">
                  INFORMACIÓN RECOGIDA EN COLABORACIÓN CON TERCEROS
                </h3>
                <p class="notion-text">
                  En la prestación de nuestros servicios haremos uso de software
                  y/o servicios de terceros para la recogida de información de
                  manera pasiva, mientras el usuario navega o interactúa con el
                  contenido de nuestro sitio web o aplicación. El único
                  propósito de recoger esta información de manera pasiva es
                  conocer mejor de qué manera el usuario utiliza e interactúa
                  con nuestra app para mejorar la experiencia de usuario
                  mientras este hace uso de nuestros servicios e identificar
                  posibles errores en la implementación de nuestra web. La
                  información recogida incluye, entre otros:
                </p>
                <ul class="notion-list notion-list-disc">
                  <li><p>La dirección IP de su dispositivo</p></li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    <p>
                      El tamaño de pantalla del dispositivo que sea utilizado
                      por el usuario
                    </p>
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    <p>
                      Tipo de dispositivo (identificador único del dispositivo)
                      e información sobre el tipo de navegador
                    </p>
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li><p>Localización geográfica</p></li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li><p>Idioma usado para mostrar en nuestra web</p></li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li><p>Páginas vistas</p></li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    <p>
                      Fecha y hora en las que las páginas han sido visitadas
                    </p>
                  </li>
                </ul>
                <p class="notion-text">
                  Con esta finalidad, utilizamos el servicio de análisis de web
                  de terceros como Google Analytics, que recopilarán información
                  de su navegación, mediante cookies u otros mecanismos.
                </p>
                <p class="notion-text">
                  En ningún caso Google Analytics recopilará ni almacenará datos
                  bancarios o de procesamiento de pago. Para mayor seguridad el
                  usuario puede consultar su política de privacidad en el
                  siguiente enlace:
                  <a
                    href="https://support.google.com/analytics/topic/2919631?hl=es-419&amp;amp;ref_topic=1008008"
                    class="notion-link"
                    >https://support.google.com/analytics/topic/2919631?hl=es-419&amp;amp;ref_topic=1008008</a
                  >
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">
                  FINALIDADES GENERALES DE LA INFORMACIÓN RECOGIDA
                </h3>
                <p class="notion-text">
                  La información del usuario recopilada por PROYECTOS EES se
                  utiliza para actividades como, pero no limitadas a: Poder
                  brindar acceso a nuestros servicios, mantenerlos,
                  administrarlos y mejorarlos. Como, por ejemplo, garantizar que
                  se cuenta con el/ los co-workers necesarios para brindar
                  servicios, garantizar con la realización de los servicios
                  adquiridos por medio de nuestra app, enviar información sobre
                  sus órdenes activas, así como el envío de los comprobantes
                  electrónicos de pago y recibos. Brindar una atención al
                  cliente de manera eficaz y personalizada en aras de garantizar
                  la resolución de dudas o inconvenientes que puedan
                  experimentar los usuarios al hacer uso de la plataforma de
                  PROYECTOS EES Enviar comunicaciones que han sido solicitadas o
                  aceptas bajo estos términos por el usuario que pueden incluir,
                  promociones, actualizaciones, modificaciones en nuestros
                  servicios, cupones, códigos promocionales, así como cualquier
                  otra que información que sea de interés del usuario como la
                  actualización de nuestros Términos y Condiciones de Uso y
                  estas Políticas de Privacidad. Recordar información de sesión
                  al usuario, uso de enlaces y uso de las diferentes secciones
                  de nuestra aplicación para mejorar la experiencia del usuario
                  y la personalización de la misma en la navegación dentro de la
                  app referente a búsqueda de productos. Brindar información a
                  los socios comerciales sobre el comportamiento de compra del
                  Consumidor, sin que estos puedan identificar de manera
                  individual a cada usuario, pues dicha información se entrega
                  por medio de datos números y no personales.
                </p>
                <h3 class="notion-h1">SUS DERECHOS</h3>
                <p class="notion-text">
                  PROYECTOS EES es la responsable de la base de datos y la
                  entidad ante la cual, podrán ejercerse los derechos previstos
                  en la normativa aplicable en El Salvador y aquellas normas que
                  la modifiquen o reemplacen, acreditando debidamente su
                  identidad o representación. usted podrá solicitar,
                  gratuitamente, el acceso, la rectificación, actualización
                  inclusión o modificación, cancelación y cualquier otra acción
                  relativa a su información personal.
                </p>
                <p class="notion-text">
                  PROYECTOS EES retiene la información del usuario y el perfil
                  por el tiempo en que usted mantenga su cuenta en PROYECTOS EES
                  Ud. tiene el derecho de acceder, actualizar y eliminar sus
                  datos personales, así como a oponerse al tratamiento de los
                  mismos.
                </p>
                <h3 class="notion-h1">COMUNICACIÓN CON EL USUARIO</h3>
                <p class="notion-text">
                  Al registrarse como usuario de PROYECTOS EES y utilizar
                  nuestros servicios, así como al enviar por medio de nuestra
                  página web cualquier solicitud de información, o cuando se nos
                  escriba de manera directa a nuestro correo
                  <a href="mailto:info@proyectosees.com" class="notion-link"
                    >info@proyectosees.com</a
                  >
                  el usuario autoriza a recibir comunicaciones por parte de
                  PROYECTOS EES en cualquiera de estos medios utilizados. Las
                  cuales podrán consistir, más no se limitarán a: información
                  sobre promociones, nuevos productos o socios comerciales,
                  promociones, modificación de los Términos y Condiciones de Uso
                  o de estas Políticas de Privacidad.
                </p>
                <p class="notion-text">
                  Sin embargo, el usuario también podrá decidir dejar de recibir
                  estas comunicaciones por medio de PROYECTOS EES, al
                  seleccionar la opción designada para ello al pie de correo por
                  parte de PROYECTOS EES o a través de una solicitud enviada a
                  <a href="mailto:info@proyectosees.com" class="notion-link"
                    >info@proyectosees.com</a
                  >; sin perjuicio de los daños que dicha cancelación podría
                  generar a los servicios brindados por PROYECTOS EES, como lo
                  es el envío de comprobante electrónico de PROYECTOS EES, dando
                  entonces la facultad a PROYECTOS EES de decidir no brindar los
                  servicios al usuario que cancele dicha suscripción.
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">INFORMACIÓN SOBRE COOKIES. </h3>
                <p class="notion-text">
                  Cuando los usuarios visitan sitios web, esos sitios generan
                  archivos de texto llamados cookies. Estas cookies almacenan
                  información de navegación para mejorar la experiencia en línea
                  del usuario cuando vuelve a visitar la misma página.
                  Normalmente, estos archivos contienen datos que permiten una
                  navegación personalizada y adaptada a cada usuario individual.
                  En PROYECTOS EES, utilizamos cookies por razones técnicas,
                  como recordar los detalles de inicio de sesión del usuario,
                  rastrear el uso de enlaces y facilitar el acceso a varias
                  secciones dentro de nuestra aplicación. Además, en nuestros
                  servidores se mantienen registros del servidor, que son
                  archivos de texto que contienen mensajes guardados. En
                  PROYECTOS EES utilizamos este sistema de archivos de texto
                  para guardar la navegación del usuario y patrones de
                  navegación en nuestra aplicación con el objetivo de garantizar
                  el perfecto funcionamiento de las mismas. Geolocalización La
                  geolocalización es una tecnología que utiliza datos obtenidos
                  de la computadora o dispositivo móvil de un usuario para
                  identificar su ubicación física real. En PROYECTOS EES
                  obtenemos la ubicación del usuario por medio de estas
                  coordenadas geográficas, latitud y longitud con el fin de
                  garantizar nuestro servicio de entrega y cobertura de
                  atención, para poder brindar una entrega adecuada del producto
                  solicitado por el usuario.
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">SEGURIDAD DE LOS MÉTODOS DE PAGO</h3>
                <p class="notion-text">
                  PROYECTOS EES no guarda la información sobre los métodos de
                  pago que el usuario ingresa en la plataforma, referentes a
                  número de tarjeta de crédito o códigos de seguridad. El uso de
                  las mismas solo existe cuando el usuario tiene una sección
                  activa en su dispositivo, por ello cada tarjeta está
                  almacenada en forma local en el dispositivo del usuario.
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">MEDIDAS DE SEGURIDAD</h3>
                <p class="notion-text">
                  PROYECTOS EES ha tomado las medidas necesarias para garantizar
                  la seguridad de la información personal de los usuarios. Hemos
                  implementado medidas administrativas de seguridad que protegen
                  contra posibles amenazas, incluida la pérdida, destrucción,
                  acceso no autorizado, alteración, uso o divulgación. Los
                  algoritmos de cifrado se utilizan para convertir datos a un
                  formato que solo pueden leer personas con la clave adecuada.
                  Como resultado, PROYECTOS EES garantiza que nadie tendrá
                  acceso a la contraseña personal del usuario, la cual es
                  necesaria para acceder a nuestra plataforma.
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">LIMITACIÓN DE RESPONSABILIDAD</h3>
                <p class="notion-text">
                  PROYECTOS EES toma todas las medidas administrativas y de
                  seguridad necesarias para garantizar la protección de los
                  datos del usuario. Sin embargo, el usuario reconoce y acepta
                  que el uso del sitio web o la aplicación de PROYECTOS EES se
                  realiza bajo su propio riesgo y responsabilidad. En
                  consecuencia, PROYECTOS EES queda liberada de cualquier
                  responsabilidad por los daños y perjuicios que pudieran
                  derivarse de un uso indebido o malicioso de estas plataformas.
                  PROYECTOS EES no será responsable de ninguna compensación por
                  daños o pérdidas, incluidos los daños emergentes o el lucro
                  cesante, resultantes de daños en el equipo del usuario
                  causados por virus informáticos, gusanos o cualquier otro
                  elemento dañino. Estos riesgos son inherentes al uso de
                  cualquier conexión a Internet. Asimismo, PROYECTOS EES no será
                  responsable de pérdidas o consecuencias que se produzcan en la
                  plataforma PROYECTOS EES debido a imprevistos, fuerza mayor o
                  acciones de terceros.
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">ACTUALIZACIÓN DE LA POLÍTICA DE PRIVACIDAD</h3>
                <p class="notion-text">
                  PROYECTOS EES se reserva el derecho de realizar cambios a la
                  presente Política de Privacidad, en cualquier momento y bajo
                  su sola discreción, con el único requisito de notificar a los
                  usuarios de dichas modificaciones antes de que las mismas
                  entren en vigencia. Una vez estas entren en vigencia, si el
                  usuario continúa haciendo uso de la aplicación o sitio web de
                  PROYECTOS EES, se entenderá que brinda su consentimiento para
                  que estas le sean aplicadas. En caso de dudas, no dude en
                  contactarnos a través de nuestro correo electrónico:
                  <a href="mailto:info@proyectosees.com" class="notion-link"
                    >info@proyectosees.com</a
                  >
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">NOTA SOBRE EL USO DE ESTE SITIO POR PARTE DE NIÑOS</h3>
                <p class="notion-text">
                  Esta aplicación y sitio web no están dirigidos a niños, ya que
                  nos interesa de sobremanera proteger la privacidad de los
                  niños. Por ello, no deseamos recopilar ninguna información que
                  identifique personalmente a menores de edad. Si un niño nos
                  hubiera suministrado información que lo identifica
                  personalmente, sus padres y/o tutores deberán comunicarse con
                  nosotros a través del contacto indicado debajo. En caso de
                  tomar conocimiento que los datos de un menor de edad (menor de
                  18 años) han sido proporcionados a PROYECTOS EES, eliminaremos
                  dicha información a la mayor brevedad posible.
                </p>
                <h3 class="notion-h1">DISPOSICIONES FINALES</h3>
                <p class="notion-text">
                  PROYECTOS EES puede contener enlaces con referencias a otros
                  sitios web más allá de nuestro control. Por lo cual informamos
                  que no tenemos ningún control sobre estos sitios web y que
                  nuestra Política no es aplicable a estos sitios. Sugerimos lea
                  las políticas de privacidad y los términos y condiciones de
                  los sitios web conectados o referenciados en los que usted
                  entre. Ninguna parte de esta Política supone la creación o
                  adición de algún derecho o reclamación (ya sea legal,
                  equitativo o de otro tipo) que cualquier individuo o persona
                  pueda tener según la ley, o de alguna otra forma, en contra de
                  la empresa, terceros, o sus directores respectivos, delegados,
                  empleados, agentes o representantes; ni la existencia de la
                  presente Política o su aplicación impondrá o agregará
                  obligación alguna o responsabilidad a ninguno de los
                  nombrados, que no tenga actualmente según la ley de El
                  Salvador.
                </p>
                <div class="notion-blank">&nbsp;</div>
                <h3 class="notion-h1">JURISDICCIÓN Y LEY APLICABLE</h3>
                <p class="notion-text">
                  La presente Política se encuentra regida sin excepción y en
                  todos sus términos por las leyes de la República de El
                  Salvador y será interpretada de acuerdo a ellas. Cualquier
                  controversia derivada de la presente Política, su existencia,
                  validez, interpretación, alcance o cumplimiento será sometida
                  a los tribunales ordinarios de Justicia con jurisdicción en El
                  Salvador, renunciándose en forma expresa a cualquier otro
                  fuero o jurisdicción.
                </p>
                <h3 class="notion-h1">SOLICITUD DE DIAGNOSTICO</h3>
                <p class="notion-text">
                  Servicios, ayuda y mantenimiento se hará responsable de todo
                  trabajo en el cual el cliente usuario haya solicitado la
                  visita de diagnostico, aceptado el presupuesto, así como
                  confirmado la realización de la obra, o prestación de
                  servicio, todo desde al app. Lo cual aclara que si cliente
                  recibió visita de diagnostico, pero contrató los servicios
                  fuera de la app, Servicios, ayuda y mantenimiento, se
                  desvincula de brindar cualquier tipo de garantía.
                </p>
                <p class="notion-text">
                  Así mismo el pago de la solicitud de diagnóstico, no es
                  reembolsable, debido a que corresponde al cobro por el
                  servicio de visita brindado.
                </p>
                <h3 class="notion-h1">TRABAJOS ACEPTADOS</h3>
                <p class="notion-text">
                  El usuario o cliente puede solicitar más de un servicio por
                  medio de la app, en la visita de diagnostico puede solicitar
                  directamente los servicios u obras que requiere, y confirmar
                  en la misma aplicación, la solicitud de estos. Por lo cual es
                  importante mencionar, que el profesional, no debe realizar y
                  menos cobrar por ningún trabajo que no esté contemplado como
                  anteriormente se ha especificado.
                </p>
                <h3 class="notion-h1">FORMAS DE PAGO</h3>
                <p class="notion-text">
                  El pago se realizará por medio de deposito en cuenta bancario
                  establecido por el socio profesional. Así mismo es importante
                  aclarar que el lapso de aplicación será de 48 horas, posterior
                  a que cliente haya confirmado en la aplicación la finalización
                  del servicio.
                </p>
                <h3 class="notion-h1">DÍAS DE PAGO</h3>
                <p class="notion-text">
                  Los pagos se realizarán únicamente los días martes y viernes,
                  en el transcurso del día. Posterior a que hayan transcurrido
                  las 48 horas, especficadas anteriormente en el que cliente
                  haya aceptado el servicio.
                </p>
                <p class="notion-text">
                  Esta política fue modificada y publicada en nuestro sitio web
                  el 4 de abril de 2024 y entra en vigencia a partir de la fecha
                  de publicación.
                </p>
                <p class="notion-text">
                  Copyright © Eficiencia Energética y Seguridad S.A. de C.V
                  <a href="mailto:info@proyectosees.com" class="notion-link"
                    >info@proyectosees.com</a
                  >
                  San Salvador, El Salvador.
                </p>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "policy",
  bodyClass: "policy-page",
  data() {
    return {
      social: {
        title: 'Políticas de Privacidad | Proyectos SEES',
        description: 'En Proyectos SEES brindamos solucionesintegrales en tecnología, eficiencia energética, seguridad electrónica y mantenimiento IT.',
        image: 'https://proyectosees.com/img/ees-icon.png'
      },
      current: 0,
      direction: 1,
      transitionName: "fade",
      show: false,
    };
  },
  mounted() {
    this.show = true;
  },
  head: {
    title: {
      inner: "Políticas de Privacidad",
    },
    // Meta tags
    meta() {
      return [
        { n: 'description', c: this.social.description, id: 'desc' },
        // Twitter
        { n: "twitter:card", c: "summary", id: 'twtca' },
        // { n: 'twitter:site', c: '@username', id: 'twtsi' },
        { n: "twitter:title", c: this.social.title, id: 'twtti' },
        { n: "twitter:description", c: this.social.description, id: 'twtde' },
        // { n: 'twitter:creator', c: '@username', id: 'twtcr' },
        { n: "twitter:image", c: this.social.image, id: 'twtim' },
        // Google+ / Schema.org
        { itemprop: "name", c: this.social.title, id: 'gglna' },
        { itemprop: "description", c: this.social.description, id: 'gglde' },
        { itemprop: "image", c: this.social.image, id: 'gglim' },
        // Facebook / Open Graph
        { p: "og:title", c: this.social.title, id: 'ogtit' },
        { p: "og:type", c: "website", id: 'ogtyp' },
        { p: "og:url", c: "https://proyectosees.com/policy/", id: 'ogurl' },
        { p: "og:image", c: this.social.image, id: 'ogima' },
        { p: "og:description", c: this.social.description, id: 'ogdes' },
        { p: 'og:site_name', c: 'Proyecto SEES', id: 'ogsit' },
        // { p: 'fb:app_id', c: '123456789' },
      ];
    },
    // link tags
    link: [
      { rel: 'canonical', href: 'https://proyectosees.com/policy/', id: 'canonical' },
      { rel: 'alternate', href: 'https://proyectosees.com/policy/', hreflang: "es-419", id: 'alter' },
    ],
  },
};
</script>
<style>
.section-product .info .icon > i {
  font-size: 2.5em;
}
.section-product .features img {
  max-height: 500px;
}

@media screen and (max-width: 767.87px) {
  .section-product .features img {
    max-height: 400px;
  }
}
</style>
